/**
 * Settings Drawer - Slide-out panel from right edge
 */
export class SettingsDrawer {
    constructor() {
        this.drawer = document.getElementById('settings-drawer');
        this.backdrop = document.getElementById('settings-backdrop');
        this.isOpen = false;

        this.setupEventListeners();
    }

    /**
     * Set up event listeners for closing the drawer
     */
    setupEventListeners() {
        // Close on backdrop click
        if (this.backdrop) {
            this.backdrop.addEventListener('click', () => this.close());
        }

        // Close on Escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) {
                this.close();
            }
        });
    }

    /**
     * Open the drawer
     */
    open() {
        if (!this.drawer) return;
        this.drawer.classList.add('open');
        if (this.backdrop) {
            this.backdrop.classList.remove('hidden');
        }
        this.isOpen = true;

        // Announce to screen readers
        const announcer = document.getElementById('announcer');
        if (announcer) {
            announcer.textContent = 'Settings panel opened';
        }
    }

    /**
     * Close the drawer
     */
    close() {
        if (!this.drawer) return;
        this.drawer.classList.remove('open');
        if (this.backdrop) {
            this.backdrop.classList.add('hidden');
        }
        this.isOpen = false;

        // Announce to screen readers
        const announcer = document.getElementById('announcer');
        if (announcer) {
            announcer.textContent = 'Settings panel closed';
        }
    }

    /**
     * Toggle drawer open/closed
     */
    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }
}
